import { Component } from "react";

import { Badge, Collapse, Divider, Dropdown, Layout, Menu, Select } from "antd";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { ReactComponent as SpeakerOFF } from "../../assets/mute.svg";
import { ReactComponent as SpeakerON } from "../../assets/speaker.svg";
import { collapseSideNav } from "../../store/actions/";
import { toggleSound } from "../../store/actions/orders";

import { ReactComponent as CustomersIcon } from "../../assets/icons/user.svg";
import { ReactComponent as OrdableLogo } from "../../assets/ordable.svg";
import { ReactComponent as KfhZahebLogo } from "../../assets/kfh_zaheb.svg";

import {
  AppstoreAddOutlined,
  CloseOutlined,
  DatabaseOutlined,
  DesktopOutlined,
  GlobalOutlined,
  LeftOutlined,
  LockOutlined,
  LogoutOutlined,
  MinusCircleFilled,
  MinusCircleOutlined,
  MinusOutlined,
  PlusOutlined,
  PushpinFilled,
  PushpinOutlined,
  QrcodeOutlined,
  RightOutlined,
  ShoppingCartOutlined,
  UserOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { Crisp } from "crisp-sdk-web";
import QRCode from "qrcode.react";
import { withRouter } from "react-router-dom";
import { ReactComponent as SupportIcon } from "../../assets/icons/Support2.svg";
import { ReactComponent as HelpIcon } from "../../assets/icons/help-tawk.svg";
import { getBillingDaysRemaining } from "../../helpers/billing";
import { logout } from "../../store/actions/auth";
import { switchLanguage } from "../../store/actions/config";
import QRScanDrawer from "../Orders/QRScanDrawer";
import LockScreen from "../POS/LockScreen";
import { sideNavItems } from "./sideNavItems";

const { Sider } = Layout;
const { SubMenu } = Menu;
const { Option } = Select;

const IconStyle = {
  height: "16px",
  verticalAlign: "bottom",
  marginRight: "10px",
  fill: "#0099cc",
};

class SideNav extends Component {
  state = {
    // isHelpOpen: false,
    dropdownVisible: false,
    screenIsLocked: localStorage.getItem("lockScreen"),
    opendMainMenus: "Panel-grpPinned",
  };
  getSelectedMenuKey = () => {
    switch (window.location.pathname) {
      case "/manage/orders":
        return ["1"];
      case "/manage/business_orders":
        return ["2"];
      case "/manage/products":
        return ["3"];
      case "/manage/locations":
        return ["4"];
      case "/manage/hours":
        return ["5"];
      case "/manage/DeliveryRates":
        return ["6"];
      case "/manage/DeliveryConfig":
        return ["7"];
      case "/manage/appearance/Identity":
        return ["8"];
      case "/manage/appearance/Features":
        return ["9"];
      case "/manage/appearance/LayoutTheme":
        return ["10"];
      case "/manage/appearance/InvoiceSettings":
        return ["11"];
      case "/manage/appearance/CustomTexts":
        return ["12"];
      case "/manage/appearance/NoticeBanner":
        return ["noticebanner"];
      case "/manage/appearance/PopupBanner":
        return ["popupBanner"];
      case "/manage/promotions":
        return ["13"];
      case "/manage/coupons":
        return ["coupons"];
      case "/manage/permissions":
        return ["14"];
      case "/manage/Integration/Delivery":
        return ["15"];
      case "/manage/Integration/Payment":
        return ["16"];
      case "/manage/Integration/Marketing":
        return ["17"];
      case "/manage/businesses":
        return ["18"];
      case "/manage/bookings":
        return ["events"];
      case "/manage/services":
        return ["appointments"];
      case "/manage/reports/overview":
        return ["reportsOverview"];
      case "/manage/reports/downloads":
        return ["downloads"];
      case "/manage/reports/customers":
        return ["customersReport"];
      case "/manage/reports/promotions":
        return ["promotionsReport"];
      case "/manage/reports/delivery":
        return ["deliveryReport"];
      case "/manage/waitlists":
        return ["waiting-lists"];
      case "/manage/feedback":
        return ["23"];
      case "/manage/survey":
        return ["survey-list"];
      case "/manage/customers":
        return ["24"];
      case "/manage/raffle":
        return ["25"];
      case "/manage/reports/sales":
        return ["sales"];
      case "/manage/reports/smaps":
        return ["sales"];
      case "/manage/reports/closing":
        return ["28"];
      case "/manage/reports/tables":
        return ["table"];
      case "/manage/reports/products":
        return ["byProductReport"];
      case "/manage/Integration/Messaging":
        return ["30"];
      case "/manage/limits":
        return ["limits"];
      case "/manage/pos":
        return ["pos"];
      case "/manage/billing":
        return ["98"];
      case "/manage/staff":
        return ["99"];
      case "/manage/ServiceProviders":
        return ["serviceProviders"];
      case "/manage/Integration/InventoryManagement":
        return ["InventoryManagement"];
      case "/manage/home":
        return ["home"];
      case "/manage/faqs":
        return ["faqs"];
      case "/manage/pending":
        return ["pending"];
      case "/manage/settings":
        return ["settings"];
      case "/manage/addons":
        return ["addons"];
      case "/manage/InstalledAddons":
        return ["installedAddons"];
      case "/manage/tables":
        return ["tables"];
      case "/manage/users":
        return ["users"];
      case "/manage/topups":
        return ["topups"];
      case "/manage/wallet":
        return ["wallet"];

      case "/manage/MobileNotifications":
        return ["mobileNotifications"];

      case "/manage/optimize":
        return ["optimize"];
    }
  };

  showDeliveryTab = () => {
    const { settings } = this.props;
    if (
      (settings.enable_ogo ||
        settings.enable_mirsal ||
        settings.enable_frontlines ||
        settings.enable_flick ||
        settings.enable_snoonu ||
        settings.enable_urwagon ||
        settings.enable_tam ||
        settings.enable_deliverix ||
        settings.enable_kangaroo ||
        settings.enable_dhl ||
        settings.enable_quick_delivery ||
        settings.enable_parcel ||
        settings.enable_fodo ||
        settings.enable_delivery_runners) &&
      settings.enable_dispatching
    )
      return true;
    return false;
  };

  showInventoryTab = () => {
    const { settings } = this.props;
    if (
      settings.enable_inflow ||
      settings.enable_cin7 ||
      settings.enable_vend ||
      settings.enable_pos_rocket ||
      settings.enable_revel ||
      settings.enable_ocims ||
      settings.enable_axanta ||
      settings.enable_ribox ||
      settings.enable_deliverect ||
      settings.enable_hike ||
      settings.enable_focus ||
      settings.enable_foodics ||
      settings.enable_matix ||
      settings.enable_invo ||
      settings.enable_urban_piper ||
      settings.enable_homey ||
      settings.enable_empower ||
      settings.enable_nbox ||
      settings.enable_grubtech ||
      settings.enable_allow ||
      settings.enable_abraj ||
      settings.enable_microsys ||
      settings.enable_paydo
    )
      return true;
    return false;
  };

  onCollapse = () => {
    this.props.collapseSideNav();
  };

  shouldShowBillingBadge = () => {
    const { info } = this.props;
    if (!info) return false;
    if (!info.next_payment_date) return false;
    if (
      info.package === 0 &&
      this.props.settings.store_status !== "demo" &&
      info.commission_value + info.addons_fee === 0
    )
      return false;

    const diff = getBillingDaysRemaining(info);
    if (diff === null) return false;
    if (this.props.settings.store_status === "demo") return diff <= 0;
    if (diff < info.notify_before) return true;
    return false;
  };

  onLanguageChange = (value) => {
    this.props.switchLanguage(value);
    this.setState({ dropdownVisible: false });
  };

  onStoreChange = (value) => {
    if (!value.includes(window.location.hostname)) window.location.href = value;
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.settings && !this.state.QRuri && !this.props.hideHeader) {
      const qrCodeCanvas = document.querySelector("#QR");
      const qrCodeDataUri = qrCodeCanvas.toDataURL("image/jpg", 0.3);
      this.QRCodeUri = qrCodeDataUri;
      this.setState({ QRuri: qrCodeDataUri });
    }

    const associatedStores = JSON.parse(
      JSON.stringify(this.props.associated_stores)
    );
    const prevAssociatedStores = JSON.parse(
      JSON.stringify(prevProps.associated_stores)
    );
    const { settings } = this.props;
    const nowHasNewOrders = !!associatedStores.filter(
      (x) =>
        x.has_pending_orders?.count &&
        x.store__sites__domain !== settings.domain
    ).length;

    const didHaveNewOrders = !!prevAssociatedStores.filter(
      (x) =>
        x.has_pending_orders?.count &&
        x.store__sites__domain !== settings.domain
    ).length;

    if (!didHaveNewOrders && nowHasNewOrders) {
      this.props.setNewOrderBellAggregate(true);
    } else if (didHaveNewOrders && !nowHasNewOrders) {
      this.props.setNewOrderBellAggregate(false);
    }
  };

  fetchAssociatedStoresPendingOrders = async (domain) => {
    try {
      const res = await axios.post(
        `https://${domain}/get_orders/`,
        {
          returnPromiseCount: true,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.success) {
        this.props.updateAssociatedStore(domain, res.data.count);
        // if (domain !== this.props.settings.domain && res.data.count)
        //   this.props.setNewOrderBellAggregate();
      }
    } catch (e) {
      console.error(e);
    }
  };

  componentDidMount = () => {
    if (
      this.props.settings.enable_aggregate_dash_notifications &&
      this.props.associated_stores.length > 1
    ) {
      const domains = this.props.associated_stores.filter(
        (x) =>
          !x.has_pending_orders &&
          x.store__sites__domain !== this.props.settings.domain
      );
      if (domains.length) {
        domains.forEach((d) =>
          this.fetchAssociatedStoresPendingOrders(d.store__sites__domain)
        );
      }
      const { settings } = this.props;
      const associatedStores = this.props.associated_stores;
      const nowHasNewOrders = !!associatedStores.filter(
        (x) =>
          x.has_pending_orders?.count &&
          x.store__sites__domain !== settings.domain
      ).length;

      if (!this.props.bellHasNewAggregate && !!nowHasNewOrders)
        this.props.setNewOrderBellAggregate(true);
    }
  };

  associatedStoresHaveOrders = () => {
    const { associated_stores, settings } = this.props;
    if (associated_stores.length <= 1) return false;

    return !!associated_stores.filter(
      (x) =>
        x.has_pending_orders?.count &&
        x.store__sites__domain !== settings.domain
    ).length;
  };
  addPinnedItem = (newItem) => {
    const { userId } = this.props;
    const pinnedItems =
      JSON.parse(localStorage.getItem(`pinnedItems-${userId}`)) || [];
    pinnedItems.push(newItem);
    localStorage.setItem(`pinnedItems-${userId}`, JSON.stringify(pinnedItems));
    this.setState({}); // to render
  };
  removePinnedItem = (itemKey) => {
    const { userId } = this.props;
    let pinnedItems =
      JSON.parse(localStorage.getItem(`pinnedItems-${userId}`)) || [];
    pinnedItems = pinnedItems.filter((pn) => pn.key !== itemKey);
    localStorage.setItem(`pinnedItems-${userId}`, JSON.stringify(pinnedItems));
    this.setState({}); // to render
  };

  render() {
    const {
      t,
      config,
      permissions,
      feedback_exists,
      hideHeader,
      sideNavCollapsed,
      settings,
      username,
      userPinCode,
    } = this.props;
    const { screenIsLocked } = this.state;
    // const settings = { ...this.props.settings, go_store: true };
    const menu = (
      <Menu style={{ width: 200 }}>
        <CloseOutlined
          style={{
            position: "absolute",
            top: 12,
            right: 10,
            cursor: "pointer",
          }}
          onClick={() =>
            this.setState({ dropdownVisible: !this.state.dropdownVisible })
          }
        />
        <p
          className="mb-2 mt-1 text-center"
          style={{
            margin: "auto",
            maxWidth: 150,
            textOverflow: "ellipsis",
            overflow: "hidden",
            fontSize: 11,
          }}
        >
          {username}
        </p>
        <Divider style={{ width: 120, margin: "5px 0px" }} />

        {this.props.associated_stores.length > 1 && (
          <>
            <Menu.Item>
              <span>
                {this.associatedStoresHaveOrders() && (
                  <span
                    className="dot-red"
                    style={{
                      position: "absolute",
                      top: 4,
                      [config.direction === "rtl" ? "right" : "left"]:
                        config.direction === "rtl" ? 24 : 28,
                    }}
                  ></span>
                )}
                <DesktopOutlined
                  style={{
                    fontSize: 16,
                    [`margin${
                      config.direction === "ltr" ? "Right" : "Left"
                    }`]: 8,
                  }}
                />{" "}
                <Select
                  value={`https://${
                    window.location.hostname
                  }/manage?token=${localStorage.getItem("token")}`}
                  style={{ width: 145, position: "relative", right: 0 }}
                  onChange={this.onStoreChange}
                  size="small"
                >
                  {this.props.associated_stores.map((s) => (
                    <Option
                      value={`https://${
                        s.store__sites__domain
                      }/manage?token=${localStorage.getItem("token")}`}
                      style={{
                        textAlign:
                          config.direction === "ltr" ? "left" : "right",
                      }}
                    >
                      {s.store__sites__domain !== settings.domain &&
                        !!s.has_pending_orders?.count && (
                          <span
                            className="dot-red"
                            style={{
                              [config.direction === "rtl"
                                ? "margin-left"
                                : "margin-right"]: 7,
                            }}
                          ></span>
                        )}
                      {config.language === "arabic"
                        ? s.store__ar_name || s.store__name
                        : s.store__name}
                    </Option>
                  ))}
                </Select>
              </span>
            </Menu.Item>
            <Divider style={{ width: 120, margin: "5px 0px" }} />
          </>
        )}
        <Menu.Item
          onClick={() => {
            this.setState({ dropdownVisible: false });
            this.props.history.push("/manage/profile");
          }}
        >
          <span>
            <UserOutlined
              style={{
                fontSize: 16,
                [`margin${config.direction === "ltr" ? "Right" : "Left"}`]: 8,
              }}
            />{" "}
            {t("Profile")}
          </span>
        </Menu.Item>
        <Menu.Item onClick={() => this.setState({ dropdownVisible: false })}>
          <a href={this.state.QRuri} download="QR Code">
            <QrcodeOutlined
              style={{
                fontSize: 16,
                [`margin${config.direction === "ltr" ? "Right" : "Left"}`]: 8,
              }}
            />{" "}
            {t("QR Code")}
          </a>
        </Menu.Item>

        {settings.enable_advanced_inventory_system &&
          (userPinCode?.trim() || "").length == 4 && (
            <>
              <Menu.Item
                onClick={() => {
                  this.setState({ dropdownVisible: false });
                  localStorage.setItem("lockScreen", 1);
                  this.setState({ screenIsLocked: true });
                }}
              >
                <span>
                  <LockOutlined
                    style={{
                      fontSize: 16,
                      [`margin${
                        config.direction === "ltr" ? "Right" : "Left"
                      }`]: 8,
                    }}
                  />
                  {t("Lock Screen")}
                </span>
              </Menu.Item>
            </>
          )}

        <Divider style={{ width: 120, margin: "5px 0px" }} />

        <Menu.Item>
          <span>
            <GlobalOutlined
              style={{
                fontSize: 16,
                [`margin${config.direction === "ltr" ? "Right" : "Left"}`]: 8,
              }}
            />{" "}
            <Select
              value={config.language}
              style={{ width: 145, position: "relative", right: 0 }}
              onChange={this.onLanguageChange}
              size="small"
              //suffixIcon={<GlobalOutlined />}
            >
              <Option value="english">English</Option>
              <Option value="arabic">عربي</Option>
            </Select>
          </span>
        </Menu.Item>

        <Divider style={{ width: 120, marginBottom: 5, marginTop: 7 }} />
        <Menu.Item
          onClick={() => {
            this.setState({ dropdownVisible: false });
            this.props.logout();
          }}
        >
          <span>
            <LogoutOutlined
              style={{
                fontSize: 16,
                [`margin${config.direction === "ltr" ? "Right" : "Left"}`]: 8,
              }}
            />{" "}
            {t("Logout")}
          </span>
        </Menu.Item>
      </Menu>
    );
    const MenuItem = {
      backgroundColor: "#F3F4F8",
      color: "#555555",
      direction: config.direction,
    };
    const IconStyleB = {
      height: "16px",
      width: "16px",
      verticalAlign: "middle",
      fill: "#0099cc",
      position: "relative",
      bottom: "3px",
      marginLeft: config.direction == "ltr" ? "0px" : "15px",
      marginRight: config.direction == "rtl" ? "0px" : "15px",
    };

    if (hideHeader) return null;

    const dividerStyle = {
      background: "#AAAAAA",
      width: "70%",
      margin: "20px auto",
      height: 1,
    };

    const sectionTitlesStyle = {
      color: "#333333",
      [`padding${config.direction === "ltr" ? "Left" : "Right"}`]: 24,
      textAlign: config.direction === "ltr" ? "left" : "right",
      lineHeight: "35px",
      marginBottom: 0,
      backgroundColor: "#f3f4f8",
    };

    ////test
    const menuItems = sideNavItems(this.props);
    const renderItem = (node) => {
      if (!node.isVisible) return null;

      if (node.type === "group") {
        const isActive = this.state.opendMainMenus.includes(
          `Panel-${node.key}`
        );
        return (
          <Collapse.Panel
            id={node.key}
            className={`header-menu-collapse-border ${
              isActive ? "header-menu-collapse-border-blue" : ""
            }`}
            header={
              <>
                <span
                  style={{
                    color: isActive && "#0099cc",
                  }}
                >
                  {t(node.label)}{" "}
                </span>
                {node.showBadge && <Badge className={"badge-text-top"} dot />}
              </>
            }
            key={`Panel-${node.key}`}
          >
            <Menu
              inlineIndent={12}
              key={`Menu-${node.key}`}
              theme="dark"
              onClick={() => {
                if (window.screen.width < 500) this.props.collapseSideNav();
              }}
              // defaultSelectedKeys={this.getSelectedMenuKey()}
              mode="inline"
              // style={{
              //   [`border${config.direction === "ltr" ? "Right" : "Left"}`]:
              //     "1px solid #ccc",
              //   background: "#F3F4F8",
              //   height: "calc(100% - 64px)",
              //   boxShadow: `${
              //     config.direction === "ltr" ? "1" : "-1"
              //   }px 3px 9px 0px #e4e4e4`,
              // }}
            >
              {node.children?.map((child) =>
                renderItem({ ...child, group: node.key })
              )}
            </Menu>
          </Collapse.Panel>
          // </Collapse>
        );
      }
      if (node.type === "submenu") {
        return (
          <Menu.SubMenu
            id={node.key}
            key={node.key}
            children={node.children?.map((child) =>
              renderItem({ ...child, group: node.group, submenu: node.key })
            )}
            title={
              <>
                {node.icon}
                <span>{t(node.label)} </span>
                {node.showBadge && <Badge className={"badge-text-top"} dot />}
              </>
            }
            className={"SubMenu"}
            style={{
              backgroundColor: "#006391",
              margin: 0,
              borderBottom: "#0099cc 1px solid;",
              ...MenuItem,
            }}
          />
        );
      }

      const content = (
        <>
          <span
            style={{
              color: node.key === "requestFeature" ? "#00a200" : undefined,
            }}
          >
            {t(node.label)}
          </span>
          {node.showBadge && <Badge className={"badge-text-top"} dot />}
        </>
      );

      return (
        <Menu.Item
          key={node.key}
          id={node.key}
          className={
            node.submenu
              ? config.direction === "ltr"
                ? "SubMenuItem"
                : "SubMenuItemAr"
              : "MenuItem"
          }
          style={{
            margin: 0,
            marginTop: 0,
            backgroundColor: node.type === "sub-item" ? "#006391" : "#fff",
            ...MenuItem,
          }}
          onClick={(e) => {
            if (e.domEvent.target.closest(".pin-navitem")) {
              return;
            }
            if (node.onClick) {
              node.onClick();
              return;
            }
            if (node.key === "attendance-scanqr") {
              // TODO: maybe add it in the sideNavItems
              this.setState({ scanDrawerOpen: true });
              return;
            }
            // Carry the active filter/date query string when hopping between the
            // new report workspaces (drop the per-report section/tab keys).
            const reportFilterRoutes = [
              "/manage/reports/overview",
              "/manage/reports/sales",
              "/manage/reports/products",
              "/manage/reports/customers",
              "/manage/reports/promotions",
              "/manage/reports/delivery",
            ];
            let targetRoute = node.route;
            const currentLocation = this.props.history.location;
            if (
              currentLocation &&
              currentLocation.search &&
              reportFilterRoutes.includes(node.route) &&
              reportFilterRoutes.includes(currentLocation.pathname) &&
              currentLocation.pathname !== node.route
            ) {
              const params = new URLSearchParams(currentLocation.search);
              params.delete("section");
              params.delete("tab");
              const carried = params.toString();
              targetRoute = carried ? `${node.route}?${carried}` : node.route;
            }
            this.props.history.push(targetRoute, node.routeState);
          }}
        >
          {node.icon}

          {content}
          {!node.isPinned && (
            <PushpinOutlined
              className="pin-navitem"
              style={{
                position: "absolute",
                right: config.direction === "ltr" && 0,
                left: config.direction === "rtl" && 0,
                top: "50%",
                transform: "translate(-50%, -50%)",
                color: "#555555",
              }}
              onClick={(e) => {
                e.nativeEvent.stopPropagation();
                this.addPinnedItem({
                  key: node.key,
                  submenu: node.submenu,
                  group: node.group,
                });
              }}
            />
          )}
          {node.isPinned && node.key !== "Home-Menu" && (
            <MinusCircleOutlined
              className="pin-navitem"
              style={{
                position: "absolute",
                right: config.direction === "ltr" && 0,
                left: config.direction === "rtl" && 0,
                // left: 0,
                top: "50%",
                transform: "translate(-50%, -50%)",
                color: "#555555",
              }}
              onClick={(e) => {
                e.nativeEvent.stopPropagation();
                this.removePinnedItem(node.key);
              }}
            />
          )}
        </Menu.Item>
      );
    }; ///

    const items = [
      {
        key: "orders",
        icon: <ShoppingCartOutlined />,
        label: (
          <span>
            Orders <Badge status="error" dot style={{ marginLeft: 6 }} />
          </span>
        ),
        children: [
          { key: "orders:online", label: "Online" },
          { key: "orders:business", label: "BusinessOrders" },
          { key: "orders:abandoned", label: "Abandoned" },
        ],
      },
      {
        key: "products",
        icon: <AppstoreAddOutlined />,
        label: "Products",
        children: [{ key: "products:suppliers", label: "Suppliers" }],
      },
      {
        key: "inventory",
        icon: <DatabaseOutlined />,
        label: "Inventory",
        children: [{ key: "inventory:suppliers", label: "Suppliers" }],
      },
    ];

    return (
      <>
        {this.state.scanDrawerOpen && (
          <QRScanDrawer
            onClose={() => this.setState({ scanDrawerOpen: false })}
          />
        )}
        {settings.enable_advanced_inventory_system &&
          (userPinCode?.trim() || "").length == 4 && (
            <LockScreen
              screenIsLocked={screenIsLocked}
              setScreenIsLocked={(value) =>
                this.setState({ screenIsLocked: value })
              }
            />
          )}

        <Sider
          collapsible
          collapsed={sideNavCollapsed}
          onCollapse={this.onCollapse}
          breakpoint="md"
          collapsedWidth="0"
          zeroWidthTriggerStyle={{
            marginTop: 4,
            [config.direction === "ltr" ? "left" : "right"]: "100%",
            top: -4,
            position: "absolute",
            backgroundColor:
              settings.linked_to_store === "foodics.ordable.com" &&
              this.props.is_staff
                ? "#5830c5"
                : "#0099cc",
            width: 20,
            height: 28,
            [`borderTop${config.direction === "ltr" ? "Right" : "Left"}Radius`]:
              "50%",
            [`borderBottom${
              config.direction === "ltr" ? "Right" : "Left"
            }Radius`]: "50%",
          }}
          style={{
            backgroundColor: "#F3F4F8",
            borderRight: "none",
            position: window.screen.width < 500 && "absolute",
            zIndex: 200,
          }}
          trigger={
            <div>
              {sideNavCollapsed ? (
                config.direction === "ltr" ? (
                  <RightOutlined
                    style={{
                      top: -11,
                      left: -1,
                      fontSize: 12,
                    }}
                  />
                ) : (
                  <LeftOutlined
                    style={{
                      top: -11,
                      right: -1,
                      fontSize: 12,
                    }}
                  />
                )
              ) : config.direction === "ltr" ? (
                <LeftOutlined
                  style={{
                    top: -12,
                    left: -3,
                    fontSize: 12,
                  }}
                />
              ) : (
                <RightOutlined
                  style={{
                    top: -12,
                    right: -3,
                    fontSize: 12,
                  }}
                />
              )}
            </div>
          }
        >
          <div style={{ display: "none" }}>
            <QRCode
              value={settings ? `https://${settings.domain}` : ``}
              size={500}
              id={"QR"}
            />
          </div>
          <div
            className="text-center row"
            style={{
              height: 74,
              width: "100%",
              direction: config.direction,
              backgroundColor: settings.enable_kfh_store
                ? "#43B02A"
                : settings.linked_to_store === "foodics.ordable.com" &&
                  this.props.is_staff
                ? "#5830c5"
                : "#0099cc",
              padding: "2px",
              margin: "0px",
            }}
          >
            <div className="col-12 p-0">
              <span
                style={{
                  color: "white",
                  marginTop: 14,
                  marginBottom: 0,
                  direction: config.direction,
                  fontSize: 25,
                  wordBreak: "break-word",
                  lineHeight: 2.5,
                  display:
                    window.location.hostname?.includes("enable.qa") ||
                    settings.dashboard_is_whitelabel
                      ? "none"
                      : "inline",
                }}
              >
                {settings.enable_kfh_store ? (
                  <KfhZahebLogo
                    style={{ width: 125, height: 50, marginBottom: 10 }}
                  />
                ) : (
                  <OrdableLogo
                    style={{ width: 125, height: 50, marginBottom: 10 }}
                  />
                )}
              </span>
            </div>
          </div>

          <Menu
            theme="dark"
            defaultSelectedKeys={this.getSelectedMenuKey()}
            mode="inline"
            style={{
              [`border${config.direction === "ltr" ? "Right" : "Left"}`]:
                "1px solid #ccc",
              background: "#F3F4F8",
              height: "calc(100% - 64px)",
              boxShadow: `${
                config.direction === "ltr" ? "1" : "-1"
              }px 3px 9px 0px #e4e4e4`,
            }}
            onClick={() => {
              if (window.screen.width < 500) this.props.collapseSideNav();
            }}
          >
            {!settings.is_menu && (
              <>
                {" "}
                <div
                  style={{
                    position: "absolute",
                    left: -90,
                    right: 0,
                    top: 57,
                    zIndex: 2,
                    width: 35,
                    height: 35,
                    borderRadius: "50%",
                    background: "white",
                    margin: "auto",
                    border: "1px solid #ccc",
                    cursor: "pointer",
                    display: sideNavCollapsed ? "none" : "grid",
                    justifyContent: "center",
                    alignContent: "center",
                  }}
                  onClick={() => this.props.toggleSound()}
                >
                  {this.props.soundEnabled ? (
                    <SpeakerON
                      style={{
                        width: 14,
                        height: 14,
                        fill: "#52c41a",
                      }}
                    />
                  ) : (
                    <SpeakerOFF
                      style={{
                        width: 14,
                        height: 14,
                        fill: "#ff4d4f",
                      }}
                    />
                  )}
                </div>
              </>
            )}

            <div
              style={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 51,
                zIndex: 2,
                width: 45,
                height: 45,
                borderRadius: "50%",
                background: "white",
                margin: "auto",
                border: "1px solid #ccc",
                cursor: "pointer",
                display: sideNavCollapsed ? "none" : "grid",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <Dropdown
                overlay={menu}
                placement="bottomLeft"
                visible={this.state.dropdownVisible}
                //onVisibleChange={(e) => {
                //  if (!this.state.dropdownVisible)
                //   this.setState({ dropdownVisible: e });
                //}}
                //trigger={["click", "hover"]}
              >
                <>
                  {this.associatedStoresHaveOrders() && (
                    <span
                      className="dot-red"
                      style={{
                        position: "absolute",
                        top: 3,
                        [config.direction === "rtl" ? "left" : "right"]:
                          config.direction === "rtl" ? 1 : -2,
                      }}
                    ></span>
                  )}
                  {this.props.userPhoto ? (
                    <img
                      src={this.props.userPhoto}
                      style={{
                        width: 45,
                        height: 45,
                        borderRadius: "50%",
                        border: "1px solid #ccc",
                      }}
                      onClick={() => {
                        this.setState({
                          dropdownVisible: !this.state.dropdownVisible,
                        });
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: 45,
                        height: 45,
                        display: "grid",
                        justifyContent: "center",
                        alignContent: "center",
                      }}
                      onClick={() => {
                        this.setState({
                          dropdownVisible: !this.state.dropdownVisible,
                        });
                      }}
                    >
                      <CustomersIcon style={{ width: 14, height: 14 }} />
                    </div>
                  )}
                </>
              </Dropdown>
            </div>
            {(!settings.linked_to_store ||
              settings.linked_to_store === "foodics.ordable.com" ||
              settings.domain === "demo.enable.qa") && (
              <div
                style={{
                  position: "absolute",
                  left: 90,
                  right: 0,
                  top: 57,
                  zIndex: 2,
                  width: 35,
                  height: 35,
                  borderRadius: "50%",
                  background: "white",
                  margin: "auto",
                  border: "1px solid #ccc",
                  cursor: "pointer",
                  display: sideNavCollapsed ? "none" : "grid",
                  justifyContent: "center",
                  alignContent: "center",
                }}
                onClick={() => {
                  if (this.props.isHelpOpen) {
                    Crisp.chat.hide();
                  } else {
                    Crisp.chat.show();
                    Crisp.chat.open();
                  }
                  this.props.toggleHelp();
                }}
              >
                <SupportIcon style={{ width: 20, height: 20 }} />
              </div>
            )}

            <Divider style={{ width: 120, margin: "5px 0px", marginTop: 40 }} />

            {(!settings.linked_to_store ||
              settings.linked_to_store === "foodics.ordable.com" ||
              settings.domain === "demo.enable.qa") && (
              <Menu.Item
                className={"MenuItem"}
                key="help"
                style={{
                  margin: 0,
                  backgroundColor: "#006391",
                  ...MenuItem,
                }}
                onClick={() => {
                  if (this.props.isHelpOpen) {
                    Crisp.chat.hide();
                  } else {
                    Crisp.chat.show();
                    Crisp.chat.open();
                  }
                  this.props.toggleHelp();
                }}
              >
                <HelpIcon style={{ ...IconStyleB, bottom: 0 }} />
                <span
                  className="no-user-selection"
                  style={{
                    color: this.props.isHelpOpen && "#47B02C",
                    position: "relative",
                    top: 1,
                  }}
                >
                  {t(this.props.isHelpOpen ? "Hide chat" : "Chat Support")}
                </span>
              </Menu.Item>
            )}

            <Divider style={{ width: 120, margin: "5px 0px" }} />

            <Collapse
              ghost
              // accordion={true}
              className={"header-menu-collapse"}
              // defaultActiveKey={node.defaultOpen && `Panel-${node.key}`}]
              activeKey={
                config.runTutorial
                  ? menuItems
                      .filter((m) => m.type === "group")
                      .map((m) => `Panel-${m.key}`)
                  : this.state.opendMainMenus
              }
              expandIconPosition={"end"}
              bordered={false}
              style={{
                [`padding${config.direction === "rtl" ? "Right" : "Left"}`]: 12,
              }}
              key={`Collapse`}
              expandIcon={({ isActive }) =>
                isActive ? (
                  <MinusOutlined style={{ color: "#0099cc" }} />
                ) : (
                  <PlusOutlined />
                )
              }
              onChange={(keys) => {
                this.setState({
                  opendMainMenus: keys.includes("Panel-grpPinned")
                    ? ["Panel-grpPinned", keys.at(-1)]
                    : [keys.at(-1)],
                });
              }}
            >
              {menuItems.map(renderItem)}
            </Collapse>
          </Menu>
        </Sider>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settings: state.auth.settings,
    permissions: state.auth.permissions,
    config: state.config,
    username: state.auth.username,
    userId: state.auth.user_id,
    soundEnabled: state.orders.soundEnabled,
    is_staff: state.auth.is_staff,
    bellHasNewOrders: state.orders.bellHasNewOrders,
    bellHasNewBusinessOrders: state.businessOrders.bellHasNewBusinessOrders,
    hasPendingPurchaseOrder: state.orders.hasPendingPurchaseOrder,
    feedback_exists: state.feedbacks.feedback_exists,
    showCustomerBookingBadge: state.customerBookings.newItem,
    showServiceBookingBadge: state.serviceBookings.newItem,
    showDownloadsBadge: state.reports.newDownloadItems.length > 0,
    hideHeader: state.pos.hideHeader,
    sideNavCollapsed: state.pos.sideNavCollapsed,
    info: state.account.info,
    urgentIssues:
      state.health?.issues?.filter((i) => i.urgency === 1)?.length || false,
    userPhoto: state.profile.profile?.photo,
    associated_stores: JSON.parse(JSON.stringify(state.auth.associated_stores)),
    profile: state.profile,
    isHelpOpen: state.orders.isHelpOpen,
    bellHasNewAggregate: state.orders.bellHasNewAggregate,

    userPinCode: state.profile.profile?.pin_code || state.auth.pin_code,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    toggleSound: () => dispatch(toggleSound()),
    collapseSideNav: () => dispatch(collapseSideNav()),
    switchLanguage: (language) => dispatch(switchLanguage(language)),
    logout: () => dispatch(logout()),
    toggleHelp: () => dispatch({ type: "TOGGLE_HELP" }),
    updateAssociatedStore: (domain, count) =>
      dispatch({
        type: "UPDATE_ASSOCIATED_STORE",
        payload: { domain, count },
      }),
    setNewOrderBellAggregate: (v) =>
      dispatch({ type: "SET_NEW_ORDER_BELL_AGGREGATE", payload: v }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(SideNav)));
